import styled from 'styled-components';

export const LottieWrapper = styled.div``;
